import { ChangeDetectorRef, Component, NgZone, OnInit, inject } from '@angular/core';
import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { BehaviorSubject } from 'rxjs';
import { LayoutHeaderService } from 'src/app/core/services/layout-header.service';
import { PermissionAccess, PermissionItem } from 'src/app/core/models/enum/permission.enum';
import { PermissionModule } from 'src/app/shared/permission/permission.module';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
  standalone: true,
  imports: [CdsIconModule, PermissionModule, CdsLanguageModule],
})
export class AdminHeaderComponent implements OnInit {
  private layoutHeaderService = inject(LayoutHeaderService);
  private zone = inject(NgZone, { optional: true }) ?? ({ run: <T>(fn: () => T) => fn() } as NgZone);
  private cdr = inject(ChangeDetectorRef, { optional: true }) ?? ({ detectChanges: () => undefined } as ChangeDetectorRef);

  permissionAccess = PermissionAccess.W;
  permissionItem = PermissionItem.COMMISSION_SCHEME_MASTER_RECORD;
  title = '';
  backIconType = 'action:button_left_filled';
  isShowButton = false;
  isShowBackButton = false;
  backButtonText = 'backButtonText';
  method = new BehaviorSubject(Event);
  buttonText = '';
  iconType = 'action:edit';
  detailDes = '';
  isShowDetail = false;

  ngOnInit(): void {
    this.isShowDetail = false;
    this.layoutHeaderService.getTitle().subscribe(t => {
      this.runInUiDeferred(() => {
        this.title = t;
      });
    });
    this.layoutHeaderService.buttonText.subscribe(t => {
      this.runInUiDeferred(() => {
        this.buttonText = t;
      });
    });
    this.layoutHeaderService.isShowButton.subscribe(t => {
      this.runInUiDeferred(() => {
        this.isShowButton = t;
      });
    });
    this.layoutHeaderService.iconType.subscribe(t => {
      this.runInUiDeferred(() => {
        this.iconType = t;
      });
    });
    this.layoutHeaderService.isShowBackButton.subscribe(t => {
      this.runInUiDeferred(() => {
        this.isShowBackButton = t;
      });
    });
    this.layoutHeaderService.backButtonText.subscribe(t => {
      this.runInUiDeferred(() => {
        this.backButtonText = t;
      });
    });
    this.layoutHeaderService.detailText.subscribe(t => {
      this.runInUiDeferred(() => {
        this.detailDes = t;
        this.isShowDetail = this.detailDes !== '';
      });
    });
  }
  doMethod(): void {
    this.layoutHeaderService.doButtonMethod();
  }

  doBackMethod(): void {
    this.layoutHeaderService.doBackButtonMethod();
  }

  private runInUiDeferred(work: () => void): void {
    // Keep header state mutations out of the current check cycle to avoid NG0100.
    setTimeout(() => {
      this.zone.run(() => {
        work();
        if (!(this.cdr as any)?.destroyed) {
          this.cdr.detectChanges();
        }
      });
    });
  }
}
